export enum ScheduledOperationStatusEnum {
    Unknown,
    Created,
    Requested,
    Approved,
    Modified,
    Removed,
    Activated,
    Terminated,
    Cancelled,
    Revoked,
    PendingAuth
}